import React from 'react';

const CircleComp: React.FC<
  React.PropsWithChildren<{
    color?: string;
    width?: string | number;
  }>
> = ({color = undefined, children, width = undefined}) => {
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: width ?? '32px',
        aspectRatio: 1,
        borderRadius: '50%',
        backgroundColor: color ?? '#F5FBF3'
      }}
    >
      {children}
    </span>
  );
};

export default CircleComp;
